/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type V1QuizAdminQuestionsListDifficulty = typeof V1QuizAdminQuestionsListDifficulty[keyof typeof V1QuizAdminQuestionsListDifficulty];


export const V1QuizAdminQuestionsListDifficulty = {
  easy: 'easy',
  hard: 'hard',
  medium: 'medium',
} as const;
